/* eslint-disable no-unused-expressions */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import {
  Box,
  Avatar,
  Stack,
  Typography,
  Card,
  Divider,
  ButtonBase,
} from '@mui/material';
import { styled } from '@mui/system';
import { tokens } from '../../../tokens';

const CVVIButton = styled(ButtonBase)(({ theme }) => ({
  position: 'relative',
  height: 200,
  [theme.breakpoints.down('sm')]: {
    width: '100% !important', // Overrides inline-style
    height: 100,
  },
  '&:hover, &.Mui-focusVisible': {
    zIndex: 99,
    '& .MuiImageBackdrop-root': {
      opacity: 0.15,
      backgroundColor: tokens.token_apple_grey,
    },
    '& .MuiImageMarked-root': {
      opacity: 0,
    },
    '& .MuiTypography-root': {
      border: '4px solid currentColor',
    },
  },
}));

const CVVIBackdrop = styled('span')(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundColor: tokens.token_surface,
  opacity: 0,
  transition: theme.transitions.create('opacity'),
}));

const LogoMarked = styled('span')(({ theme }) => ({
  height: '22px',
  width: '92px',
  // backgroundColor: tokens.token_black,
  position: 'absolute',
  top: 5,
  right: 'calc(70% - 9px)',
  '&:hover, &.Mui-focusVisible': {
    zIndex: 99,
    '& .MuiImageBackdrop-root': {
      opacity: 0.15,
    },
  },
  transition: theme.transitions.create('opacity'),
}));

const NameTypo = styled(Typography)(() => ({
  fontFamily: 'Roboto, Arial,sans-serif',
  fontSize: '.85rem',
  fontWeight: 400,
  color: tokens.token_text_grey_on_white,
  lineHeight: '1.00rem',
  letterSpacing: '.025em',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textAlign: 'left',
}));

const DataTypo = styled(Typography)(() => ({
  fontFamily: 'Google Sans, Roboto, Arial, sans-serif',
  fontSize: '0.85rem',
  fontWeight: 500,
  lineHeight: '1.00rem',
  letterSpacing: '.025em',
  textAlign: 'left',
  color: tokens.token_typography_regular_emphasized,
}));

const DefTypo = styled(Typography)(() => ({
  fontFamily: 'Roboto, Arial,sans-serif',
  fontSize: '.75rem',
  fontWeight: 400,
  color: tokens.token_text_grey_on_white,
  lineHeight: '1.00rem',
  letterSpacing: '.025em',
  // whiteSpace: 'nowrap',
  // overflow: 'hidden',
  // textOverflow: 'ellipsis',
  textAlign: 'left',
}));
const IndexTypo = styled(Typography)(() => ({
  fontFamily: 'Google Sans, Roboto, Arial, sans-serif',
  fontSize: '0.85rem',
  fontWeight: 500,
  lineHeight: '1.00rem',
  letterSpacing: '.025em',
  textAlign: 'left',
  color: tokens.palette_primary,
}));

const DescCard = styled(Box)(() => ({
  border: '1px solid',
  borderColor: 'transparent',
  borderRadius: '12px',
  maxWidth: '425px',
  height: '225px',
  paddingRight: '16px',
  paddingLeft: '16px',
  paddingTop: '16px',
  paddingBottom: '4px',
  backgroundColor: tokens.token_surface,
  // '&:hover': {
  //   boxShadow: '0 0 5px #9aa0a6',
  // },
}));
// const ReactSpeedometer = dynamic(() => import('react-d3-speedometer'), {
//   ssr: false,
// });
export default function AboutCryptoCVVIDesc() {
  return (
    <DescCard sx={{}}>
      <Stack direction="row" spacing={1} justifyContent="space-between">
        <Stack>
          <NameTypo>1 week ago</NameTypo>
          <DataTypo>Balance</DataTypo>
        </Stack>

        <Avatar
          sx={{ bgcolor: '#ffb987', width: 28, height: 28 }}
          aria-label="CVVI Value"
        >
          <IndexTypo>55</IndexTypo>
        </Avatar>
      </Stack>
      <Divider sx={{ my: '5px' }} />
      <Stack direction="row" spacing={1} justifyContent="space-between">
        <Stack>
          <NameTypo>1 month ago</NameTypo>
          <DataTypo>Vice</DataTypo>
        </Stack>

        <Avatar
          sx={{
            bgcolor: tokens.palette_secondary,
            width: 28,
            height: 28,
          }}
          aria-label="CVVI Value"
        >
          <IndexTypo>87</IndexTypo>
        </Avatar>
      </Stack>
      <Divider sx={{ my: '5px' }} />
      <DefTypo>
        blockquiry's Crypto Vice and Virtue Index™ is used to gauge the trust of
        the crypto community in the overall viability, safety, and security of
        the crypto ecosystem.{' '}
      </DefTypo>
    </DescCard>
  );
}
